import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const VisualizerBounceListItem = (props) => {
    const { visualizerBounceFactor, updateVisualizerSettings, maxBounceFactor } = props;
    
    const onBounceChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ bounceFactor: value });
    };
    
    return (
        <SliderListItem
            title='Bounce'
            value={visualizerBounceFactor}
            displayMultiplier={100 / maxBounceFactor}
            min={0}
            max={100}
            step={1}
            onValueChange={onBounceChange}
            toolTip='How much the visualizer size increases during loud audio.'
        />
    );
};

const mapStateToProps = (state) => {
    const { bounceFactor: visualizerBounceFactor } = state.createPreview.present.videoSettings.visualizer;
    const { maxBounceFactor } = state.create.maxValues;

    return { 
        visualizerBounceFactor,
        maxBounceFactor
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerBounceListItem);